import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCompare,
  GuideSectionLabel,
  GuideBlockList,
} from "../GuideBlocks.js";

const UnderstandingAngerSection = ({ heading, accentIndex = 3, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="understanding-anger"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Anger is often misunderstood. It is usually not the first emotion. Instead, anger often
      protects deeper emotions such as hurt, fear, rejection, disappointment, shame, or helplessness.
    </GuideLead>
    <p className="guide-panel__p">
      Think of anger as the visible part of an iceberg. Beneath the surface are emotions that often
      need attention.
    </p>
    <GuideCompare
      leftTitle="Deliberate anger"
      rightTitle="Reactive anger"
      left={
        <GuideBlockList
          items={["Protects boundaries.", "Encourages fairness.", "Motivates positive action."]}
        />
      }
      right={
        <GuideBlockList
          items={["Blames.", "Attacks.", "Damages relationships.", "Leads to regret."]}
        />
      }
    />
    <GuideSectionLabel>When anger appears, ask yourself</GuideSectionLabel>
    <GuideBlockList
      items={[
        "What happened?",
        "What am I protecting?",
        "What emotion exists underneath this anger?",
        "What response aligns with my values?",
      ]}
    />
    <GuideCallout variant="amber">These questions turn reactive anger into examined insight.</GuideCallout>
  </GuidePanel>
);

export default UnderstandingAngerSection;
